<template>
	<CardGeneric
		v-if="runtimeConfig.public.ENABLE_COUPON_CODES"
		class="text-left max-sm:pb-4">
		<p class="cardTitle">{{ $t("discountCodesTitle") }}</p>
		<p class="cardSubTitle">{{ $t("discountCodesSubtitle") }}</p>

		<CheckoutRedeemCode />
		<CheckoutApplyCoupon :show-input="false" />
		<CheckoutApplyCredits :show-input="false" />
	</CardGeneric>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()
</script>

<style scoped></style>
